export default __webpack_public_path__ + "images/product/skin_types/sensitive-a97f267908d902fdd4322f87f0491ac1.svg";